<template>
  <div class="fhlfx-wrap">
    <resize-container :tabShow="tabShow">
      <div class="tree-content box" v-show="tabShow" slot="left">
        <tab-tree
          :data="viewTreeData"
          @tabTreeDefault="tabTreeDefault"
          @tabTreeClick="tabTreeClick"
          @changeCompany="changeCompany"
        ></tab-tree>
      </div>
      <div class="content">
        <div class="search-box box">
          <time-search
            ref="timeSearch"
            :control="{ data: timeType }"
            @timeControlChange="timeControlChange"
            @timeControlClick="TimeControlClick"
          ></time-search>
        </div>
        <div class="grid-content">
          <btn-show @show="tabShow = !tabShow" content="左边树"></btn-show>
          <div class="main">
            <div class="echarts-wrap">
              <div class="header">负荷率分析</div>
              <div class="echarts-main">
                <div :id="id" class="echarts" v-resize="resize"></div>
              </div>
            </div>
            <div class="table-wrap">
              <el-table
                size="mini"
                :data="tableData"
                border
                :header-cell-style="tableHeaderColor"
              >
                <el-table-column
                  align="center"
                  prop="maxData"
                  label="最大负荷率(%)"
                ></el-table-column>
                <el-table-column
                  align="center"
                  prop="maxDataTime"
                  label="最大负荷率发生时间"
                ></el-table-column>
                <el-table-column
                  align="center"
                  prop="minData"
                  label="最小负荷率(%)"
                ></el-table-column>
                <el-table-column
                  align="center"
                  prop="minDataTime"
                  label="最小负荷率发生时间"
                ></el-table-column>
                <el-table-column
                  align="center"
                  prop="allData"
                  label="月平均负荷率(%)"
                ></el-table-column>
              </el-table>
              <div class="bottomcontent">
                <div class="leftcontent" v-if="changecolor">
                  <div class="leftname">良好</div>
                  <div class="rightname">
                    业主负荷率控制合理，建议结合业主的实际情况，通过合理调
                    整生产、作业、活动安排，加强负荷预测和负荷监控，达到用电负荷均衡化。
                  </div>
                </div>
                <div class="leftcontent" v-if="!changecolor">
                  <div class="leftnametwo">需改进</div>
                  <div class="rightname">
                    业主负荷率控制不合理，建议结合业主的实际情况，通过合理调
                    整生产、作业、活动安排，加强负荷预测和负荷监控，达到用电负荷均衡化。
                  </div>
                </div>
                <div class="rightcontent">
                  日负荷率计算公式:日平均负荷与最大负荷之比。
                  <br />按照《GB3485 - 1998企业合理用电导则》
                  <br />对于连续性生产的企业，负荷率应大于等于95%;
                  <br />对于三班制(24小时) 生产的企业，负荷率应大于等于85%;
                  <br />对于二班制(16小时)生产的企业，负荷率应大于等于60%;
                  <br />对于一班制(8小时)生产的企业，负荷率应大于等于30%。
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </resize-container>
  </div>
</template>

<script>
import uuidv1 from "uuid/v1";
import TabTree from "@/components/common/TabTree.vue";
import { findDataByParam } from "@/utils/index.js";
import handleData from "@/utils/handleData.js";
import TimeSearch from "@/components/common/TimeSearch.vue";
import BtnShow from "@/components/common/BtnShow.vue";
import dateTool from "@/utils/dateTool.js";
import echarts from "echarts";
import ResizeContainer from "@/components/common/resizeContainer.vue";
export default {
  data() {
    return {
      timeType: [{ type: "month", label: "月" }],
      viewTreeData: [], //树数据
      selectedMeasure: {
        //当前选中的树数据
        measureId: "",
        measureName: "",
      },
      timeElem: {}, //当前的时间参数
      tabShow: true, //左边的树是否显示
      id: uuidv1(),
      title: ["日平均负荷率"],
      titlename: "日平均负荷率曲线图",
      showcontent: true,
      warnValue: 85, //警戒线值
      tableData: [],
      changecolor: true,
    };
  },
  components: {
    TabTree,
    TimeSearch,
    BtnShow,
    ResizeContainer,
  },
  mounted() {},
  methods: {
    resize() {
      this.myChart && this.myChart.resize();
    },
    async changeCompany(companyId) {
      //获取树数据
      let res =
        await this.$api.frontEndPageCustomParam.getMyFrontEndPageCustomParam(
          companyId,
          "/nyyh/fhlfx",
          null
        );
      this.viewTreeData = findDataByParam("viewTree", true, res.data); //数据赋值
      this.warnValue = findDataByParam("warnValue", false, res.data);
    },
    async getData() {
      //根据参数获取数据
      const element = this.selectedMeasure;
      let one = [
        {
          measureId: element.measureId,
          pointNumber: 0,
          pointCode: "233",
        },
      ];
      this.getQuantityData(one);
    },
    tabTreeDefault(e) {
      //首次加载树时执行，保留默认的树选择
      this.selectedMeasure = e;
      this.getData(); //获取数据
    },
    tabTreeClick(e) {
      //树节点点击的时候触发
      this.selectedMeasure = e;
      this.getData(); //获取数据
    },
    timeControlChange(e) {
      //时间下拉框切换时触发
      this.timeElem = e;
    },
    TimeControlClick(e) {
      //时间点击查询时
      this.timeElem = e;
      this.getData();
    },
    getQuantityData(one) {
      let arr = [];
      arr.push(
        this.$api.quantity.getQuantityDay3(
          one,
          this.timeElem.startTime,
          this.timeElem.endTime,
        )
      );
      arr.push(
        this.$api.quantity.getQuantityMonth2(
          one,
          this.timeElem.startTime,
          this.timeElem.endTime,
        )
      );
      Promise.all(arr).then((res) => {
        let pjdata;
        if (res[1].data[0].data.length == 0) {
          pjdata = "-";
        } else {
          pjdata = res[1].data[0].data[0].value.toFixed(2);
        }
        let xData = handleData.createXData(
          this.timeElem.dateType,
          this.timeElem.startTime,
          this.timeElem.endTime
        );
        //找到对应计量点id和代码的数据
        let xArr = [];
        let dataItem = [];
        let itemData = res[0].data[0].data[0];
        for (let k = 0; k < xData.length; k++) {
          let item = itemData.find(
            (obj) => strToDate(obj.time, "d").getTime() == xData[k].value
          );
          xArr.push(xData[k].title);
          dataItem.push(item ? item.value.toFixed(2) * 1 : "-");
        }
        let obj = {
          title: this.titlename,
          legend: this.title,
          dataone: dataItem,
          length: xArr,
        };
        this.fillEcharts(obj);
        this.getTable(itemData, pjdata);
        if (itemData.length == 0) {
          this.showcontent = false;
        } else {
          this.showcontent = true;
        }
        function strToDate(date, dateType) {
          let time = null;
          if (dateType == "h") {
            time = dateTool.format(new Date(date), "yyyy-MM-dd hh") + ":00:00";
          } else if (dateType == "d") {
            time = dateTool.format(new Date(date), "yyyy-MM-dd") + " 00:00:00";
          } else if (dateType == "m") {
            time = dateTool.format(new Date(date), "yyyy-MM") + "/01 00:00:00";
          }
          return new Date(time);
        }
      });
    },
    fillEcharts(obj) {
      let vm = this;
      this.myChart = echarts.init(document.getElementById(this.id));
      var option = {
        title: {
          text: obj.title,
          left: "center",
        },
        grid: {
          x: 50,
          y: 50,
          x2: 50,
          y2: 60,
          borderWidth: 10,
        },
        tooltip: {
          trigger: "axis",
        },
        legend: {
          data: obj.legend,
          top: "6%",
        },
        dataZoom: [
          {
            type: "inside",
            show: true,
            realtime: true,
          },
          {
            show: true,
            realtime: true,
            end: 100,
            type: "slider",
            width: "92%",
            left: "center",
          },
        ],
        toolbox: {
          show: true,
          feature: {
            magicType: { show: true, type: ["line", "bar"] },
            saveAsImage: { show: true },
          },
        },
        calculable: true,
        color: "#00AAFF",
        xAxis: [
          {
            type: "category",
            data: obj.length,
          },
        ],
        yAxis: [
          {
            type: "value",
            name: "%",
            max: function (val) {
              let max = 0;
              if (val.max < Number(vm.warnValue)) {
                max = Math.ceil(Number(vm.warnValue) * 1.2);
              } else {
                max = Math.ceil(val.max * 1.2);
              }
              return max;
            },
          },
        ],
        series: [
          {
            name: obj.legend,
            data: obj.dataone,
            type: "line",
            smooth: true,
            markLine: {
              label: {
                formatter: "{c}" + "%",
                position: "end", //将警示值放在哪个位置，三个值“start”,"middle","end"  开始  中点 结束
              },
              data: [
                {
                  silent: false, //鼠标悬停事件  true没有，false有
                  lineStyle: {
                    //警戒线的样式  ，虚实  颜色
                    type: "solid",
                    color: "#FA3934",
                  },
                  yAxis: this.warnValue, // 警戒线的标注值，可以有多个yAxis,多条警示线   或者采用   {type : 'average', name: '平均值'}，type值有  max  min  average，分为最大，最小，平均值
                },
              ],
            },
          },
        ],
      };
      this.myChart.setOption(option, true);
      if (this.myChart) {
        window.addEventListener("resize", () => {
          this.myChart.resize();
        });
      }
    },
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      //改表头颜色
      if (rowIndex === 0) {
        return "background-color: #F3F3F3;color: #666;font-size:14px";
      }
    },
    getTable(e, data) {
      if (e.length == 0) {
        this.tableData = [];
        return;
      }
      const max = e.reduce((prev, current) =>
        prev.value > current.value ? prev : current
      );
      const min = e.reduce((prev, current) =>
        prev.value < current.value ? prev : current
      );
      let alldata = 0;
      for (let i = 0; i < e.length; i++) {
        alldata += e[i].value;
      }
      let alltime = e.length;
      let allData = (alldata / alltime).toFixed(2);
      if (data < this.warnValue) {
        this.changecolor = false;
      } else {
        this.changecolor = true;
      }
      this.tableData = [
        {
          maxData: max.value.toFixed(2) + "%",
          maxDataTime: max.time,
          minData: min.value.toFixed(2) + "%",
          minDataTime: min.time,
          allData: data + "%",
        },
      ];
    },
  },
};
</script>

<style lang='scss' scoped>
.fhlfx-wrap {
  width: 100%;
  height: 100%;
  display: flex;
  overflow: hidden;
  padding: 23px;
  box-sizing: border-box;
  .tree-content {
    width: 100%;
    margin-right: 14px;
  }
  .content {
    position: relative;
    width: 100%;
    height: 100%;
    .search-box {
      height: 36px;
      .option {
        width: 150px;
        margin: 0 0 0 10px;
      }
    }
    .grid-content {
      position: absolute;
      bottom: 0;
      width: 100%;
      top: 50px;
      border-radius: 4px;
      box-sizing: border-box;
      .main {
        width: 100%;
        height: 100%;
        display: flex;
        flex-flow: column;
        .echarts-wrap {
          width: 100%;
          margin-bottom: 14px;
          flex: 2;
          background: #fff;
          border-radius: 4px;
          padding: 10px;
          box-sizing: border-box;
          position: relative;
          .header {
            width: 100%;
            height: 44px;
            background: #63a8eb;
            border: 1px solid #63a8eb;
            border-bottom: none;
            box-sizing: border-box;
            border-radius: 4px 4px 0 0;
            font-size: 18px;
            font-weight: bold;
            line-height: 44px;
            text-align: left;
            padding-left: 10px;
          }
          .echarts-main {
            position: absolute;
            top: 54px;
            bottom: 10px;
            left: 10px;
            right: 10px;
            border: 1px solid #dedee1;
            border-radius: 0 0 4px 4px;
            border-top: none;
            .echarts {
              width: 100%;
              height: 100%;
            }
          }
        }
        .table-wrap {
          width: 100%;
          flex: 1;
          background: #fff;
          border-radius: 4px;
          padding: 10px;
          box-sizing: border-box;
          .bottomcontent {
            color: #000;
            text-align: left;
            display: flex;
            overflow: hidden;
            padding-top: 10px;
            box-sizing: border-box;
            .leftcontent {
              border: 1px solid #dedcdc;
              flex: 1;
              margin-right: 10px;
              border-radius: 4px;
              display: flex;
              justify-content: center;
              align-items: center;
              .leftname {
                color: green;
                font-size: 40px;
                flex: 1;
                text-align: center;
              }
              .leftnametwo {
                font-size: 40px;
                flex: 1;
                text-align: center;
              }
              .rightname {
                white-space: normal;
                flex: 3;
              }
            }
            .rightcontent {
              border: 1px solid #dedcdc;
              height: 100%;
              flex: 1;
              border-radius: 4px;
              padding: 5px;
              box-sizing: border-box;
            }
          }
        }
      }
    }
  }
}
</style>
